import React, { FC } from 'react';
import { ReactComponent as EllipsisIcon } from '@blink/assets/src/icons/ellipsisV.svg';
import { ReactComponent as MailIcon } from '@blink/assets/src/icons/mail.svg';

import { useResendInvite } from '../hooks/useResendInvite';

import { Popover, PopoverTrigger, PopoverContent, TooltipWrapperDisabled } from '@/shared/ui';

type TeamTooltipProps = {
    name: string;
    email: string;
    disabled?: boolean;
};

export const TeamTooltip: FC<TeamTooltipProps> = ({ name, email, disabled }) => {
    const handleResendInvite = useResendInvite(name, email);

    if (disabled) {
        return <TooltipWrapperDisabled component={<EllipsisIcon />} />;
    }

    return (
        <Popover>
            <PopoverTrigger asChild className='hover:text-content-primary'>
                <EllipsisIcon />
            </PopoverTrigger>
            <PopoverContent className='flex justify-between items-center'>
                <div className='flex flex-col items-start text-primary [&>svg]:self-center'>
                    <div
                        className='flex w-[152px] gap-3 hover:bg-secondary [&.remove]:text-negative [&.remove_svg_rect]:fill-negative justify-center items-center cursor-pointer'
                        onClick={handleResendInvite}
                    >
                        <MailIcon />
                        Resend Invite
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    );
};
